import moment from 'moment';

import { FieldName, SearchField } from '../models/SearchField';

export const newSearchField = (optionSelected: FieldName, operator?, id?): SearchField => {
  switch (optionSelected) {
    case 'Agreement Date':
      return {
        id: id || moment.now().toString(),
        fieldName: optionSelected,
        value: '',
        operator: operator || '='
      };
    case 'File No':
      return {
        id: id || moment.now().toString(),
        fieldName: optionSelected,
        value: '',
        operator: operator || '≈'
      };
    case 'Status':
    case 'Company Name':
      return {
        id: id || moment.now().toString(),
        fieldName: optionSelected,
        value: []
      };
    case 'Notes':
    case 'Initial Agreement':
      return {
        id: id || moment.now().toString(),
        fieldName: optionSelected,
        value: '',
        operator: '≈'
      };
  }
};

export default newSearchField;
